const isTillClosed = (till) => till.status === 'CLOSED';
export const retrieveClosedTills = (tills) => tills.filter(isTillClosed);

export const isTillActive = (till) => till.status === 'ACTIVE';

export const retrieveOpenTills = (tills) => tills.filter(isTillActive);

export const arePendingLoansAvailable = ({ pendingLoans }) => Object.keys(pendingLoans).length > 0;
